import { useForm } from "react-hook-form";
import { FormContainer, SelectInput } from "../../shared";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { UPDATE_SITE_ADMIN_USER } from "./query";
import { USER_TYPE_LIST, clearCache } from "../../../utils";
import { USER_TYPE_SYSTEM_ADMIN } from "../../../utils/userLists";

const UpdateAdminType = ({ id, userType }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            userType,
        },
    });

    const userTypeList =
        userType === 99 ? [...USER_TYPE_LIST, { ...USER_TYPE_SYSTEM_ADMIN }] : USER_TYPE_LIST;

    const { submitMutation, loading } = useGlobalMutation(UPDATE_SITE_ADMIN_USER, (cache) =>
        clearCache(cache, "getAdminUserList")
    );

    const submitAction = handleSubmit(async (data) => {
        const { userType } = data;

        const variables = {
            id,
            userPatch: {
                userType: Number(userType),
            },
        };

        const dataPath = "updateUserById.user";
        const successMessage = "Admin Update Successfully";

        await submitMutation(variables, dataPath, successMessage);
    });

    return (
        <FormContainer
            submitAction={submitAction}
            submitButtonText="Update"
            submitBtnSm
            loading={loading}
        >
            <div className="row">
                <div className="col-md-6">
                    <h5 className="mb-4">Update Admin Type</h5>
                    <SelectInput
                        labelText="Admin Type"
                        id="userType"
                        name="userType"
                        options={userTypeList}
                        required
                        {...register("userType", {
                            required: true,
                        })}
                        isInvalid={!!errors.userType}
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default UpdateAdminType;
